import { render, staticRenderFns } from "./PostEditorContainer.vue?vue&type=template&id=01699a0b&scoped=true&"
import script from "./PostEditorContainer.vue?vue&type=script&lang=js&"
export * from "./PostEditorContainer.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorContainer.vue?vue&type=style&index=0&id=01699a0b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01699a0b",
  null
  
)

export default component.exports